import { render, staticRenderFns } from "./BookingCalendarWeekDesktopHeader.vue?vue&type=template&id=01609a58"
import script from "./BookingCalendarWeekDesktopHeader.vue?vue&type=script&lang=js"
export * from "./BookingCalendarWeekDesktopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports